import { Name, IContractAmendmentDetails as IContractAmendmentDetails } from "./AmendNameAddressRequest";
import * as Models from "..";

export interface IContractAmendmentCustomerDetails {
    originalAddress: Models.Customer.Address.Address;
    originalName: Name;
    originalTrustName: string;
    originalIsInTrust: boolean;
    contractAmendmentInProgress: boolean;
    customerHasSignedElectronicConsent: boolean;
    customerHasSignedContract: boolean;
    documentsInProgress: boolean;
    currentContractAmendmentDetails: IContractAmendmentDetails;
}

export class ContractAmendmentCustomerDetails implements IContractAmendmentCustomerDetails {
    originalAddress: Models.Customer.Address.Address;
    originalName: Name;
    originalTrustName: string;
    originalIsInTrust: boolean;
    contractAmendmentInProgress: boolean;
    customerHasSignedElectronicConsent: boolean;
    customerHasSignedContract: boolean;
    documentsInProgress: boolean;
    currentContractAmendmentDetails: IContractAmendmentDetails;
}
